import { createFileRoute } from '@tanstack/react-router';
import StubPage from '@/pages/StubPage.jsx';

function DashboardRoute() {
  return <StubPage name="dashboard" />;
}

export const Route = createFileRoute('/dashboard')({ component: DashboardRoute });
